import React, { memo } from 'react';

import PropTypes from 'prop-types';

import localization from '../../../../shared/strings';
import { AGGREGATED_FIELD_STATE } from '../../../../store/products/helpers/aggregatedFieldState';
import Category from '../../Category';
import { aggregatedCategoryFieldPropType } from '../helpers/aggregatedFieldPropTypes';
import { mapAggregatedFieldToInputProps } from '../helpers/mapAggregatedFieldToInputProps';
import { resolveAggregatedFieldTooltip } from '../helpers/resolveAggregatedFieldTooltip';
import { useBindAggregatedField } from '../hooks/useBindAggregatedField';
import styles from './AggregatedBrand.module.scss';

const l10n = localization.PRODUCT_INFO;
const aggregatedL10n = l10n.aggregated;

const AggregatedCategory = ({
  field,
  readOnly,
  readOnlyTooltip,
  isDiff,
}) => {
  const fieldLabel = l10n.autoMappedFieldLabels.category;
  const bindings = useBindAggregatedField('category', field, fieldLabel);
  const inputProps = mapAggregatedFieldToInputProps(field);

  if (!field || field.state === AGGREGATED_FIELD_STATE.NOT_APPLICABLE) return null;

  const isMultiple = field.state === AGGREGATED_FIELD_STATE.MULTIPLE;
  const isReadOnly = readOnly || inputProps.readOnly;
  const value = field.state === AGGREGATED_FIELD_STATE.COMMON ? (field.value ?? null) : null;
  const multiplePlaceholder = isMultiple ? aggregatedL10n.multipleValues : null;
  const canSet = !isReadOnly;
  const tooltip = resolveAggregatedFieldTooltip({
    field,
    layerReadOnly: readOnly,
    layerReadOnlyTooltip: readOnlyTooltip,
    canSet,
    canClear: canSet && (isMultiple || Boolean(value)),
  });

  return (
    <div className={styles.wrapper}>
      <Category
        value={value}
        readOnly={isReadOnly}
        readOnlyTooltip={readOnly ? readOnlyTooltip : null}
        tooltip={tooltip}
        isDiff={isDiff}
        filterText={multiplePlaceholder}
        placeholder={multiplePlaceholder}
        onChange={isReadOnly ? undefined : bindings.onChange}
      />
    </div>
  );
};

AggregatedCategory.propTypes = {
  field: aggregatedCategoryFieldPropType,
  readOnly: PropTypes.bool,
  readOnlyTooltip: PropTypes.string,
  isDiff: PropTypes.bool,
};

AggregatedCategory.defaultProps = {
  field: null,
  readOnly: false,
  readOnlyTooltip: null,
  isDiff: false,
};

export default memo(AggregatedCategory);
